import { api, CustomAxiosRequestConfig } from "@/shared/api/client";
import {
    WalletSystemProfileCreateDTO,
    WalletSystemProfileNumGetDTO,
    WalletSystemProfileFileGetDTO
} from "@/shared/types/admin/walletSystemProfile";

export const walletSystemProfileService = {
    create: async (id: string, data: WalletSystemProfileCreateDTO): Promise<WalletSystemProfileNumGetDTO> => {
        const response = await api.post<WalletSystemProfileNumGetDTO>(`/system-profiles/${id}/wallets`, data, { 
            skipErrorToast: true 
        });
        return response.data;
    },

    createWithUpload: async (id: string, data: WalletSystemProfileCreateDTO, files: File[]): Promise<WalletSystemProfileFileGetDTO> => {
        const formData = new FormData();
        
        // O backend espera o DTO como uma parte "data" (Blob JSON)
        const jsonBlob = new Blob([JSON.stringify(data)], { type: "application/json" });
        formData.append("data", jsonBlob);
        
        // E os arquivos como uma parte "files" (Lista)
        files.forEach(file => {
            formData.append("files", file);
        });

        const response = await api.post<WalletSystemProfileFileGetDTO>(`/system-profiles/${id}/wallets/upload`, formData, {
            skipErrorToast: true
        });
        return response.data;
    },

    addFile: async (id: string, file: File, filename?: string): Promise<WalletSystemProfileFileGetDTO> => {
        const formData = new FormData();
        formData.append("file", file, filename || file.name);

        const response = await api.post<WalletSystemProfileFileGetDTO>(`/system-profiles/${id}/wallets/add-file`, formData, {
            skipErrorToast: true
        });
        return response.data;
    },

    addCredential: async (id: string, credential: Record<string, string>): Promise<WalletSystemProfileNumGetDTO> => {
        const response = await api.post<WalletSystemProfileNumGetDTO>(`/system-profiles/${id}/wallets/add-credential`, credential, {
            skipErrorToast: true
        });
        return response.data;
    },

    getWallet: async (id: string): Promise<WalletSystemProfileFileGetDTO> => {
        const response = await api.get<WalletSystemProfileFileGetDTO>(`/system-profiles/${id}/wallets`, {
            skipErrorToast: true
        });
        return response.data;
    },

    deleteWallet: async (id: string): Promise<void> => {
        await api.delete(`/system-profiles/${id}/wallets`, {
            skipErrorToast: true
        });
    },

    deleteCredential: async (id: string, key: string): Promise<void> => {
        await api.delete(`/system-profiles/${id}/wallets/delete-credential/${key}`, {
            skipErrorToast: true
        });
    },

    deleteFile: async (id: string, fileId: string): Promise<void> => {
        await api.delete(`/system-profiles/${id}/wallets/delete-file/${fileId}`, {
            skipErrorToast: true
        });
    },

    getFile: async (id: string, fileId: string): Promise<Blob> => {
        const response = await api.get(`/system-profiles/${id}/wallets/${fileId}`, {
            responseType: "blob",
            skipErrorToast: true
        });
        return response.data;
    },
};
